module.exports = __webpack_public_path__ + "img/pic_2_5.c3a0453c.jpg";